import React, { useState } from 'react';
import '../../styles/service-style/medical-rehabilitation.css';
import Footer from '../../components/Footer';
import { ChevronDown, ChevronUp } from 'lucide-react';
import Roaslin from '../../assets/Rehab staff/Roaslin Singh.JPG';
import JoshnaPriya from '../../assets/Rehab staff/Joshna priya.JPG';
import SaiKumarYadav from '../../assets/Rehab staff/Sai kumar Yadav.JPG';

const teamMembers = [
  {
    name: 'Rosalin Singh',
    role: 'MOT',
    bio: 'Committed to empowering individuals through daily living skill training and therapy.',
    image: Roaslin,
  },
  {
    name: 'Joshna Priya',
    role: 'Occupational Therapist',
    bio: 'Focused on improving functional independence and mental well-being.',
    image: JoshnaPriya,
  },
  
];

const sections = [
  {
    title: 'Our Occupational Therapy Services',
    items: [
      { title: 'Assessment and Evaluation', content: 'Our occupational therapists will assess and evaluate your cognitive, physical, and emotional abilities to identify areas of strength and weakness.' },
      { title: 'Customized Treatment Plans', content: 'We will develop a personalized treatment plan to address your specific needs and goals.' },
      { title: 'Activities of Daily Living (ADL) Training', content: 'Our therapists help you develop skills for daily tasks such as bathing, dressing, and grooming.' },
      { title: 'Instrumental Activities of Daily Living (IADL) Training', content: 'We train individuals in home management, medication use, meal prep, and budgeting for independent living.' },
      { title: 'Cognitive Rehabilitation and Memory Training', content: 'We help develop strategies to improve memory and cognitive function for daily performance.' },
      { title: 'Physical Rehabilitation', content: 'We support mobility and strength training through targeted exercises and therapeutic routines.' },
      { title: 'Adaptive Equipment Training and Recommendations', content: 'We guide usage and provide recommendations for assistive devices to enhance safety and independence.' },
      { title: 'Home and Workplace Modifications', content: 'We assess and suggest environmental modifications to improve accessibility at home or work.' },
      { title: 'Group and Individual Therapy Sessions', content: 'We offer both individual and group sessions based on the needs of each patient.' },
    ],
  },
  {
    title: 'Who Can Benefit?',
    items: [
      { title: 'Physical Disabilities', content: 'Including spinal cord injuries, amputations, or musculoskeletal disorders.' },
      { title: 'Cognitive Disabilities', content: 'Such as brain injuries, strokes, and memory-related conditions.' },
      { title: 'Mental Health Conditions', content: 'Including depression, anxiety, and emotional regulation challenges.' },
      { title: 'Developmental Disabilities', content: 'Autism, Down syndrome, and learning difficulties.' },
      { title: 'Chronic Illnesses', content: 'Arthritis, diabetes, and other long-term health conditions.' },
    ],
  },
  {
    title: 'Why Choose Us?',
    items: [
      { title: 'Expert Therapists', content: 'Our MOTs and experienced therapists deliver evidence-based, compassionate care.' },
      { title: 'Holistic & Personalized Plans', content: 'We design every program around your individual needs and recovery goals.' },
      { title: 'Inclusive Environment', content: 'We provide a welcoming space that empowers growth and independence.' },
    ],
  },
];

const OccupationalTherapy = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const handleToggle = (index) => setActiveIndex((prev) => (prev === index ? null : index));

  return (
    <div>

      <div className="medical-rehab-page">
        <header className="medical-rehab-header">
          <h1 className="medical-rehab-title">Occupational Therapy Services</h1>
          <p className="medical-rehab-intro">
            Welcome to the Department of Occupational Therapy at Dr. Bharathi Rao Advanced Comprehensive Rehabilitation Center
          </p>
          <p className="medical-rehab-description">
            Our occupational therapy services are designed to help individuals of all ages improve functional abilities and participate fully in daily life. Whether recovering from injury or living with chronic conditions, we’re here to help you achieve independence.
          </p>
        </header>

        <main className="medical-rehab-content">
          {sections.map((section, secIndex) => (
            <section key={secIndex} className="rehab-section">
              <h2 className="rehab-section-title">{section.title}</h2>
              <div className="rehab-accordion-grid">
                {section.items.map((item, idx) => {
                  const globalIdx = `${secIndex}-${idx}`;
                  const isActive = activeIndex === globalIdx;
                  return (
                    <div className={`rehab-accordion-item${isActive ? ' open' : ''}`} key={idx}>
                      <button
                        className="rehab-accordion-header"
                        onClick={() => handleToggle(globalIdx)}
                        aria-expanded={isActive}
                        aria-controls={`panel-${globalIdx}`}
                      >
                        <span className="icon">{isActive ? <ChevronUp /> : <ChevronDown />}</span>
                        {item.title}
                      </button>
                      <div
                        id={`panel-${globalIdx}`}
                        className="rehab-accordion-body"
                        style={{ maxHeight: isActive ? '200px' : '0px' }}
                        aria-hidden={!isActive}
                      >
                        <p>{item.content}</p>
                      </div>
                    </div>
                  );
                })}
              </div>
            </section>
          ))}

          <section className="rehab-commitment">
            <h2 className="rehab-section-title">Our Commitment</h2>
            <p>
              At Dr. Bharathi Rao Advanced Comprehensive Rehabilitation Center, we are committed to delivering evidence-based occupational therapy in a compassionate, inclusive environment. Our mission is to support every individual's journey toward meaningful and independent living.
            </p>
          </section>

          <section className="rehab-team">
            <h2 className="rehab-section-title">Meet Our Team</h2>
            <div className="rehab-team-grid">
              {teamMembers.map((member, idx) => (
                <div key={idx} className="rehab-team-card">
                  <div className="rehab-team-img">
                    <img src={member.image} alt={member.name} />
                  </div>
                  <div className="rehab-team-info">
                    <h3>{member.name}</h3>
                    <p className="role">{member.role}</p>
                    <p className="bio">{member.bio}</p>
                  </div>
                </div>
              ))}
            </div>
          </section>

          <section className="rehab-appointment">
            <h2 className="rehab-section-title">Book an Appointment</h2>
            <p>
              To learn more about our <strong>Occupational Therapy Services</strong> or to schedule an appointment, click the button below.
            </p>
            <a
              href="https://forms.gle/3kjZMUiW6qRyKpRh9"
              target="_blank"
              rel="noopener noreferrer"
              className="appointment-btn"
            >
              Book Now
            </a>
          </section>
        </main>

      </div>
      <Footer />
    </div>
  );
};

export default OccupationalTherapy;
